<template lang="pug">
div
	.flex
		.flex-grow
			p: b {{label}}
			p(v-if='task') Currently assigned.
			p(v-else) Not assigned.
		.flex-min(v-if='task')
			button.is-danger.button(@click='$emit("off")')
				font-awesome-icon(icon='times') 
		.flex-min(v-else)
			button.is-info.button(@click='$emit("on")')
				font-awesome-icon(icon='plus') 
</template>

<script>
export default {
  name: "SpecialTask",
  props: ["label", "task"],
  mounted: function() {}
};
</script>

<style scoped lang="less">
.flex {
  border: thin #dddddd solid;
  margin-bottom: 1rem;
  padding: 1rem;
  background-color: #efefef;
}
</style>
